export const getEventName = (type, salesCheckoutPage) => {
    let eventName = 'assinatura-' + type;
    if (salesCheckoutPage !== null && salesCheckoutPage.length > 0) {
        eventName = eventName + '-' + salesCheckoutPage;
    }

    return {event: eventName};
}
